<template>
  <el-link style="margin: 0 5px">
    <slot></slot>
  </el-link>
</template>
